'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var n=({nextImage:t,imgUrl:a,altText:l,className:e,...m})=>jsxRuntime.jsx("section",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-top-image ${e||""}`),children:t||jsxRuntime.jsx("img",{src:a,alt:l,...m})}),i=n;

exports.a = i;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-UTEXJU3T.js.map